import { client } from "filestack-react";
import { axiosService } from "network/axios";

// Public Filestack app key (safe to ship; NOT the signing secret).
const FILESTACK_API_KEY = process.env.REACT_APP_FILESTACK_API_KEY;

/**
 * Initialise a Filestack client for picker/direct uploads.
 *
 * P0 breach containment: once the account-wide "Use Security" toggle is ON,
 * Filestack REJECTS unsigned uploads. So we fetch a short-lived, server-signed,
 * UPLOAD-ONLY policy from the backend (GET /files/upload-policy) and pass it to
 * client.init(). The endpoint is unauthenticated (guest checkout must upload)
 * but the policy grants only pick/store/write — never read — so a scraped policy
 * can spam storage but cannot read anyone's documents.
 *
 * While security is still OFF the backend returns { securityEnabled: false } and
 * we init WITHOUT a policy — exactly today's behaviour — so this is inert until
 * the flip. The flip + FILESTACK_SECURITY_ENABLED must happen together (see
 * lx-app-be FilestackHelper).
 *
 * The signing secret is NEVER sent to the browser — only the policy+signature.
 */
export async function initFilestackClient() {
  try {
    const { data }: any = await axiosService.get("/files/upload-policy");

    if (data?.securityEnabled && data?.policy && data?.signature) {
      return client.init(FILESTACK_API_KEY, {
        security: {
          policy: data.policy,
          signature: data.signature,
        },
      });
    }
  } catch (err) {
    // Fall through to an unsigned init. That still works while security is OFF;
    // once it is ON an unsigned upload is rejected and the picker surfaces the
    // error rather than silently uploading somewhere insecure.
    console.error("Filestack upload-policy fetch failed:", err);
  }

  return client.init(FILESTACK_API_KEY);
}
